import useStyles from 'hooks/useStyles'
import styles from './Theme2.module.scss'

const Theme2 = () => {
  useStyles(styles)
  return null
}

export default Theme2
